import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import ROUTES from './routes';

export default function PublicRoute({ children }) {
  const token = useSelector(state => state.auth.accessToken);
  if (token) {
    return <Navigate to={ROUTES.ROOT} replace />;
  }

  return children;
}
